// extracted by mini-css-extract-plugin
export var container = "_j8-0";
export var dotAnimation = "_j8-2";
export var dotsLoading = "_j8-1";